import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { refreshAccessToken, saveUser } from 'redux/modules/auth'

function hoc() {
  return ComposedComponent => {
    @connect(
      ({ auth }) => ({
        user: auth.user
      }),
      { refreshAccessToken, saveUser }
    )
    class RefreshToken extends Component {
      static propTypes = {
        saveUser: PropTypes.func,
        refreshAccessToken: PropTypes.func,
        user: PropTypes.object
      }

      state = {
        interval: null
      }

      componentDidMount = () => {
        const { user } = this.props

        if (get(user, 'access_token')) {
          this.initInverval(this.handleModelUser(user))
        }
      }

      componentWillReceiveProps = nextProps => {
        const { user } = this.props

        if (
          !get(user, 'access_token') && !get(nextProps, 'user.access_token')
        ) {
          if (this.state.interval) {
            this.stopInterval(this.state.interval)
            return
          }
        }

        if (get(user, 'access_token') && !get(nextProps, 'user.access_token')) {
          this.stopInterval(this.state.interval)
        }

        if (!get(user, 'access_token') && get(nextProps, 'user.access_token')) {
          this.initInverval(this.handleModelUser(nextProps.user))
          return
        }

        if (
          get(user, 'exp') !== get(nextProps, 'user.exp') &&
          get(user, 'access_token') !== get(nextProps, 'user.access_token')
        ) {
          this.initInverval(this.handleModelUser(nextProps.user))
          return
        }
      }

      handleModelUser = (user = {}) => {
        if (!user) {
          return
        }

        const currentUnixTime = moment().unix() * 1000
        const extendBy = user.expires_in * 1000

        return {
          ...user,
          exp: currentUnixTime + extendBy
        }
      }

      initInverval = user => {
        this.setState({
          interval: this.startInterval(user)
        })
      }

      startInterval = user => {
        console.log('Refresh token monitor initialized')
        this.stopInterval(this.state.interval)

        const expirationTime = get(user, 'exp')
        const intervalPeriod = 30000

        if (moment().diff(expirationTime) > 0) {
          return null
        }

        return setInterval(() => {
          if (moment().diff(expirationTime) > -30000) {
            console.log('time to refresh!!!')
            this.props
              .refreshAccessToken(get(user, 'refresh_token'))
              .then(res => {
                const newUser = {
                  ...user,
                  ...res.body
                }

                this.props.saveUser(newUser)
              })
              .catch(err => {
                console.error('Refresh token failed', err)
              })
          }
        }, intervalPeriod)
      }

      stopInterval = interval => {
        if (interval) {
          clearInterval(interval)
        }
      }


      render() {
        return <ComposedComponent {...this.props} />
      }
    }
    return RefreshToken
  }
}

export default hoc
